function parseModelProps(modelprops) {
    const productObj = modelprops ? (modelprops.product ? modelprops.product : {}) : {};
    const noOfProd = productObj ? (productObj.numberOfProducts? (productObj.numberOfProducts + " PRODUCTS") : "") : "";
    const image = productObj ? (productObj.images? (productObj.images[0] ) : "") : "";

    return modelprops
    ? {
        ...(modelprops || {}),
        ...(modelprops.product
          ? {
            product: {
                ...modelprops.product,
                violatorProps: {
                  message: noOfProd,
                  violatorClassName: 'omen-brand-violator'
                },
                images : [image]
              }
            } : {}),
    ...(modelprops.rewardBadge
        ? {
            rewardBadge: {
                ...modelprops.rewardBadge,
                hpRewardBadgeClassName: 'omen-brand-reward-badge',
                isPositionBeforePrice: true,
            }
        } : {}),
    ...(modelprops.price 
        ? {
            priceProps : {
                ...modelprops.price,
                className: "omen-brand-mlp-price-block",
                color:'light'
            }
        } : {}
    ),
      ...(modelprops.productLinkProps 
          ? {
            productLinkProps: {
              ...modelprops.productLinkProps,
              btnProps: {
                children: modelprops.ctaBtnText,
                color: 'white',
                variation: 'secondary',
                isFullWidth: true
              },
              productLinkClassName: 'omen-brand-prod-link',
              to: modelprops.ctaLink
            },
          } : 
          {
            productLinkProps: {
                btnProps: {
                  children: modelprops.ctaBtnText,
                  color: 'white',
                  variation: 'secondary'
                },
                productLinkClassName: 'omen-brand-prod-link',
                to: modelprops.ctaLink
              }
          }
      ),
  }
: {};
}

export default parseModelProps;